import { getSocket } from './socket'

export interface ClaimResult {
  blocked: boolean
  activeOn?: { channelId: string; deviceLabel: string }
}

/**
 * Ask the server whether a live session OTHER than mine owns this channel's
 * voice. Fail-open ({blocked:false}) on timeout/error so a flaky check never
 * hard-blocks a user — callers decide how to treat that per path.
 */
export function claimVoice(channelId: string, timeoutMs = 3000): Promise<ClaimResult> {
  return new Promise((resolve) => {
    try {
      const socket = getSocket()
      let settled = false
      const done = (r: ClaimResult) => { if (!settled) { settled = true; resolve(r) } }
      const timer = setTimeout(() => done({ blocked: false }), timeoutMs)
      socket.emit('voice:claim', { channelId }, (r: ClaimResult) => {
        clearTimeout(timer)
        done(r && typeof r.blocked === 'boolean' ? r : { blocked: false })
      })
    } catch {
      resolve({ blocked: false })
    }
  })
}
